import React from "react";
import styled from "styled-components";
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import HiddenComponnent from '../common3/HiddenComponent'
import { injectIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

const Wrapper = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  padding:8px;
  flex-direction:column;

  ${p => p.inlineCSS}

`

const Text = styled.div`
  font-size:14px;
  color: #000000;
  margin-left:8px;
  margin-top: 15px;
`

const BigText = styled(Text)`
  font-size:18px;
`


const SAML = injectIntl((props) => {
  const { extra = {}, builder, user, origin, intl, formData = {} } = props;

  const { _id: formDataId } = formData

  const { label = 'Sign in with SAML', css, auth, forceRedirect, hideAuth, enableUserSwitch, disableAutoNext, redirectView } = extra;

  const history = useHistory()

  // render null if we are in admin. This is so we do not trigger unwanted SAML request when opening forms in admin
  if (origin === 'admin') {
    return null
  }

  let qParams = "?fromUrl=" + encodeURIComponent(window.location.pathname + window.location.search)

  if (formDataId) {
    qParams += `&formDataId=${formDataId}`
  }

  if (disableAutoNext) {
    qParams += `&disableAutoNext=true`
  }

  if (redirectView) {
    qParams = `?fromUrl=${encodeURIComponent(redirectView)}`
  }

  if (history.location.state && history.location.state.from) {
    qParams = `?fromUrl=${encodeURIComponent(history.location.state.from)}`
  }

  if (!builder && isEmpty(user) && forceRedirect) {
    window.location = `/saml/login${qParams}`
  }

  // 2022-03-23: Redirect view did not work 
  if (!builder && redirectView) {
    window.location = `${redirectView}`
  }

  if (hideAuth) {
    if (builder) {
      return <HiddenComponnent />
    } else {
      return null 
    }
  }

  const loggedIn = !isEmpty(user)

  const username = get(user, "attributes.name", get(user, "userName" ), null)
  // const currentUrl = new Buffer(window.location.href).toString('base64');

  return (
    <Wrapper inlineCSS={css} className="sp-saml">
      {
        loggedIn && (
          <>
            <Text>{intl.formatMessage({ id: 'SAML.Loggedin' })}</Text>
            <BigText>{username ? username : "No name"}</BigText>
          </>
        )

      }
      {
        (!loggedIn || (loggedIn && enableUserSwitch) || builder) && (
          <a href={builder ? () => { } : `/saml/login${qParams}`}>
            <Text>{label}</Text>
          </a>
        )
      }

    </Wrapper>

  );
});

export default SAML

